import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const FillCheck = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17.78 8.83L12.07 16.57C11.8 16.94 11.28 17.02 10.91 16.75L10.88 16.73L6.81 13.47C6.45 13.18 6.38999 12.66 6.67999 12.3C6.96999 11.95 7.48 11.89 7.84 12.17L11.24 14.89L16.44 7.83C16.71 7.46 17.23 7.39 17.6 7.65C17.97 7.92 18.06 8.44 17.79 8.81L17.78 8.83Z"
      fill="#565B6D"
    />
  </svg>
)

export default withDefaultStyles(FillCheck)
